import React from 'react';
import { Glob as G } from "../libs/Glob.mjs";
import {Button, ButtonGroup, UncontrolledTooltip} from "reactstrap";
import TrashIcon from "../media/images/TrashIcon.mjs";
import UserFlags from "./adminControls/UserFlags.mjs";
import TextLabel from "../controls/TextLabel.mjs";
import EditIcon from "../media/images/EditIcon.mjs";

const AdminUser = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = { me: G.getUserLogin() };
		this.uid = G.generateUid('AdminUser');
	}
	render() {
		const u = this.props.user;
		const itsMe = u.user === this.state.me;
		return(
			<tr>
				<td>
					<UserFlags user={u} />
				</td>
				<td>
					{u.user}
				</td>
				<td>
					{u.name}
				</td>
				<td>
					{ u.isAdmin ? <em>[<TextLabel value={"All"}/>]</em>: (u.groups.length ? (
						u.groups.length === 1 ? (
							u.groups[0].name
						) : (
							<span id={this.uid + '-groups' }>
								{u.groups.length} gruppi
								<UncontrolledTooltip target={this.uid + '-groups' }>
									{ u.groups.map(g => <div key={g.id}>{ g.name }</div> ) }
								</UncontrolledTooltip>
							</span>
						)
					) : ('—'))}
				</td>
				<td>
					{u.mail ?? '—'}
				</td>
				<td>
					<ButtonGroup className={"btn-icon"}>
						<Button
							id={ this.uid+'-button-edit' }
							title={`${G.label('Edit')} «${ u.user }»`}
							color={"link"}
							onClick={() => {
								this.props.editUser(u.user)
							}}
						>
							<EditIcon />
						</Button>
						<Button
							id={ this.uid+'-button-delete' }
							title={`${ G.label('Remove')} «${ u.user }»`}
							color={ "link"}
							disabled={ itsMe }
							onClick={() => {
								if ( window.confirm(G.label('ConfirmUserDeletion'))) {
									this.props.change('rmUser',{ id: u.user });
								}
							}}
						>
							<TrashIcon />
						</Button>
					</ButtonGroup>
				</td>
			</tr>
		)
	}
}

export default AdminUser;
